import { render, staticRenderFns } from "./aixinyuan.vue?vue&type=template&id=0c334560&scoped=true&"
import script from "./aixinyuan.vue?vue&type=script&lang=js&"
export * from "./aixinyuan.vue?vue&type=script&lang=js&"
import style0 from "./aixinyuan.vue?vue&type=style&index=0&id=0c334560&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c334560",
  null
  
)

export default component.exports